import merge from 'lodash/merge'
import React from 'react'
import { useError } from '../useError'

export const useCloudinaryUpload = ({ options }: any = {}): { widget: any; events: any; assets: any; clearAssets: () => void } => {
  const ref = React.useRef({ cloudinaryWidget: null, assets: [] })
  //const [assets, setAssets] = React.useState([])
  const [events, setEvents] = React.useState<any>(null)
  const { onError } = useError()

  //load the script for cloudinary, when button is shown
  React.useEffect(() => {
    //when the document object is not available, then means to say it is server side, then just ignore it
    if (!document) return

    const script = document?.createElement('script')
    script.id = 'cloudinary'
    script.src = 'https://widget.cloudinary.com/v2.0/global/all.js'
    script.async = true
    script.type = 'text/javascript'

    //append to the document
    document.body.appendChild(script)
    //when it is appended here the cloudinary object should be ready
    script.onload = () => {
      const mergedOptions = merge(
        {
          cloudName: 'tmmshauler',
          uploadPreset: 'panelpunches',
          sources: ['local', 'url', 'camera', 'google_drive', 'facebook', 'dropbox', 'instagram', 'shutterstock', 'image_search'],
          showAdvancedOptions: false,
          showCompletedButton: true,
          cropping: false,
          multiple: true,
          defaultSource: 'local',
          styles: {
            palette: {
              window: '#FFFFFF',
              windowBorder: '#90A0B3',
              tabIcon: '#0078FF',
              menuIcons: '#5A616A',
              textDark: '#000000',
              textLight: '#FFFFFF',
              link: '#0078FF',
              action: '#4ab2f1',
              inactiveTabIcon: '#0E2F5A',
              error: '#F44235',
              inProgress: '#0078FF',
              complete: '#20B832',
              sourceBg: '#E4EBF1',
            },
            fonts: { default: null, 'sans-serif': { url: null, active: true } },
          },
        },
        options
      )

      // eslint-disable-next-line no-undef
      ref.current.cloudinaryWidget = globalThis?.cloudinary?.createUploadWidget(mergedOptions, (error, { event, info, ...rest }) => {
        if (error) {
          return onError(error)
        }

        if (event === 'success' && info) {
          const format = info?.format
          const getFormat = () => {
            if (!format) {
              return 'raw'
            }

            if (format === 'mp4') {
              return 'video'
            }
            if (format === 'pdf') {
              return 'document'
            }

            return 'image'
          }

          const asset = {
            url: info?.secure_url,
            type: getFormat(),
          }

          ref.current.assets.push(asset)
          // const newAssets = [...assets, asset]
          // setAssets(newAssets)
        }

        setEvents({ event, info, ...rest })
      })
    }

    //on unmount remove the script
    return () => {
      document.body.removeChild(script)
    }
  }, [])

  const clearAssets = () => {
    ref.current.assets = []
  }

  return { widget: ref?.current?.cloudinaryWidget, assets: ref.current.assets, events, clearAssets }
}
